import React from 'react';
import classnames from 'classnames';

import { Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import { useSection } from '@hydra/common/components/ScrollSpy';

const useStyles = makeStyles(theme => ({
  wrapper: {
    paddingTop: theme.spacing(8),
    marginTop: theme.spacing(-4)
  },
  sectionHeading: {
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1)
  },
  paper: {
    borderRadius: theme.shape.borderRadius * 5,
    boxShadow: `0px 2px 2px ${theme.palette.grey[200]}`
  }
}));

export const ReviewModule = ({ module, children, className }) => {
  const classes = useStyles();
  const ref = useSection(module);

  if (!children) {
    return null;
  }

  return (
    <div
      id={`module-${module}`}
      className={classnames(classes.wrapper, className)}
      ref={ref}
    >
      <Typography
        className={classes.sectionHeading}
        variant='h3'
        color='textPrimary'
      >
        <Translate content={module} />
      </Typography>
      <Paper className={classes.paper}>
        {children}
      </Paper>
    </div>
  );
};

export default React.memo(ReviewModule);
